import PropTypes from 'prop-types';
import React from 'react';
import { BOOKING_CALENDAR_CLEAR } from '../../../../brands/default/content/components/deal';
import BookingCalendarButton from './BookingCalendarButton';

const BookingCalendarClear = ({ onClick }) => {
  const { clearSelection } = BOOKING_CALENDAR_CLEAR;

  return (
    <BookingCalendarButton
      className="clear-button"
      onClick={onClick}
      text={clearSelection}
    />
  );
};

BookingCalendarClear.propTypes = {
  onClick: PropTypes.func,
};

export default BookingCalendarClear;
